<template>
  <g 
    id="Capa_2" 
    data-name="Capa 2"
    :fill="iconColor"
  >
    <g 
      id="Capa_1-2" 
      data-name="Capa 1"
    >
      <path
        class="cls-1"
        d="M1716.61,2046.86h-30.16a21.46,21.46,0,0,0-3.21-1.12c-5.61-1-11.24-2-16.87-2.9-19.36-3.28-38.58-7.29-57.72-11.68a1407.48,1407.48,0,0,1-136.3-38.74c-48.91-16.55-96.89-35.47-144.15-56.27-57.52-25.31-113.71-53.3-169-83.13-52.68-28.41-104.43-58.44-155.58-89.51Q989.25,1754.8,975,1746a58.14,58.14,0,0,1-17.53-16.14,39,39,0,0,1-7.34-23.11,54.6,54.6,0,0,1,3.79-19.38,100.27,100.27,0,0,1,9.76-18.82,31.66,31.66,0,0,1,7.12-8.24,37.82,37.82,0,0,0,8.67-9.64,31.2,31.2,0,0,0,4.43-24.26,50.12,50.12,0,0,0-3.75-11,77.29,77.29,0,0,0-7.37-12.33A131.25,131.25,0,0,0,955,1583.14a251.9,251.9,0,0,0-19.59-16.1,327.19,327.19,0,0,0-36.26-23.36c-11.78-6.54-23.67-12.88-35.54-19.27-10.66-5.73-21.31-11.49-31.63-17.82a62.8,62.8,0,0,1-6.77-4.64,429.43,429.43,0,0,1-58.88-57.25,475.47,475.47,0,0,1-34.81-47.51q-6.54-10.07-12.4-20.52c-5-9-10.39-17.73-15.67-26.55a86.21,86.21,0,0,0-8.09-11q-21.14-25.23-44.61-48.33a597.78,597.78,0,0,0-76.7-64.08,420.46,420.46,0,0,0-59-34.76,282.9,282.9,0,0,0-46.68-17.73,187.41,187.41,0,0,0-29.52-5.88,152.19,152.19,0,0,0-30.11-.62,118.12,118.12,0,0,0-29.4,6.13c-5.38,1.9-10.82,3.66-16.31,5.18a230.19,230.19,0,0,1-56.82,8.09,310.63,310.63,0,0,1-33.55-1c-12.3-1.07-24.52-2.68-36.65-4.91a440.5,440.5,0,0,1-55.73-14.08,629.36,629.36,0,0,1-175-88A21.15,21.15,0,0,0,0,1076.21V0H2821.71V1749.36c-.68,0-1.36-.11-2.05-.11-16-.07-32,.82-47.89,2.3q-16.72,1.54-33.28,4.35a390.86,390.86,0,0,0-45.35,10.43,415.73,415.73,0,0,0-96.85,42.8c-29.7,17.78-57.16,38.57-83.06,61.48a777.64,777.64,0,0,0-61.22,60.85,51.75,51.75,0,0,1-8.68,7.72,148.61,148.61,0,0,1-31.92,17.11c-20.24,7.89-41.36,11.27-62.94,12.1a297.38,297.38,0,0,1-46.49-2.24c-13.62-1.61-27.1-3.94-40.52-6.73-20.81-4.33-41.28-9.94-61.58-16.18-21.17-6.52-42-13.92-62.83-21.55a46.11,46.11,0,0,0-7.16-2.27c-5.83-1.09-11.7-2-17.59-2.8q-14.25-1.92-28.57-3.34c-10.47-1-21-1.59-31.46-1.93a316.2,316.2,0,0,0-58.06,3.53,221,221,0,0,0-39.83,9.82c-19.59,6.91-37.46,16.82-53.15,30.53a57.23,57.23,0,0,0-9.16,10.12,172.7,172.7,0,0,1-51.16,47.93,193.73,193.73,0,0,1-35.13,16.89c-24,8.77-48.87,13.22-74.26,15.12-3.41.26-6.84.36-10.27.53A11.14,11.14,0,0,0,1716.61,2046.86Z"
      />
    </g>
  </g>
</template>

<script>
export default {
  props: {
    iconColor: {
      type: String,
      required: false,
      default: "red",
    },
    iconBorder: {
      type: String,
      required: false,
      default: "black",
    },
  },
};
</script>

<style scoped>
path {
  font-family: var(--iconFontFamily);
  font-size: var(--iconFontSize);
}
</style>